import { parseCookies } from '@cian/utils/lib/shared/cookie';

import { getPageActivity } from './pageActivity';
import { TRequestDiagnostics } from './types';
import { IApplicationContext } from '../../../types/applicationContext';
import { TAppState } from '../../../types/appState';

/**
 * Собирает условия, в которых выполняется запрос к публичной ручке чатов
 */
export function getRequestDiagnostics(state: TAppState, context: IApplicationContext): TRequestDiagnostics {
  const eventChannel = context.custom.socket?.eventChannel;
  const hasDocument = typeof document !== 'undefined';
  const hasNavigator = typeof navigator !== 'undefined';

  /** Живое значение из браузера. Расхождение с userId означает, что страница отрисована для другого пользователя */
  const cookieUserId = hasDocument ? parseCookies(document.cookie)['cookieUserID'] || null : null;

  return {
    userSessionId: context.custom.userSessionId || null,
    /** Возраст снимка авторизации: сколько прошло с серверного рендера страницы */
    snapshotAge: state.renderedAt ? Date.now() - state.renderedAt : null,
    isAuthenticated: state.user.isAuthenticated,
    userId: state.user.userId,
    cookieUserId,
    socketStatus: state.socketStatus,
    socketClosed: eventChannel ? eventChannel.isChannelClosed() : null,
    isOnline: hasNavigator ? navigator.onLine : null,
    hasFocus: hasDocument ? document.hasFocus() : null,
    visibilityState: hasDocument ? document.visibilityState : null,
    hostType: state.hostType,
    currentOpenedChatId: state.chatWindow.currentOpenedChatId || null,
    hadAuthCookieAtRender: state.hadAuthCookieAtRender === undefined ? null : state.hadAuthCookieAtRender,
    pageOrigin: hasDocument ? window.location.origin : null,
    ...getPageActivity(),
  };
}
